import { queryOptions } from '@tanstack/react-query';

import { authClient } from './auth-client';

export class UnauthenticatedError extends Error {
	constructor() {
		super('Unauthenticated');
		this.name = 'UnauthenticatedError';
	}
}

export const sessionQueryKey = ['session'] as const;

export const sessionQueryOptions = queryOptions({
	queryKey: sessionQueryKey,
	queryFn: async () => {
		const { data, error } = await authClient.getSession();
		if (error) {
			throw error;
		}
		if (!data) {
			throw new UnauthenticatedError();
		}
		return data;
	},
	retry: false,
	staleTime: 5 * 60 * 1000,
});
